import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import { DataResponse, KnowledgeBaseSchema, SortKnowledgeBaseItems } from "schema"
import { z } from "zod"
import { knowledgeBaseQuery } from "../lib/knowledgeBaseQuery"

type Response = DataResponse<z.infer<typeof KnowledgeBaseSchema>>

export function useSortKnowledgeBaseMutation() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (data: z.input<typeof SortKnowledgeBaseItems>) => {
      const response = await axios.put<Response>(`/knowledgeBase/sort`, data)

      return response.data.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [knowledgeBaseQuery().queryKey.at(0)] })
    },
  })
}
